import get from 'lodash.get';
import React, { Component, Fragment } from 'react';
import styled from 'react-emotion';

import t from '@jetshop/intl';
import { Above, Below } from '@jetshop/ui/Breakpoints';
import ActiveListFilters from '@jetshop/ui/Filter/ActiveFilters';
//import BoolFilters from '@jetshop/ui/Filter/FilterTypes/BoolFilters';
import ListFilterFlyouts from '@jetshop/ui/Filter/FilterTypes/List/ListFilterFlyouts';
//import MultiListFlyouts from '@jetshop/ui/Filter/FilterTypes/Multi/MultiListFlyouts';
import RangeFilterFlyouts from '@jetshop/ui/Filter/FilterTypes/Range/RangeFilterFlyouts';
import { DrawerTarget, DrawerTrigger } from '@jetshop/ui/Modal/Drawer';
import Drawer from './Drawer';
import SortOrderDropdown from '@jetshop/ui/SortOrder/SortOrderDropdown';
import theme from '@jetshop/ui/utils/theme';

import FilterDrawerRegular from './FilterDrawerRegular';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortAmountDown } from '@fortawesome/pro-light-svg-icons';
import { faSlidersH } from '@fortawesome/free-solid-svg-icons';
library.add(faSlidersH, faSortAmountDown);

const ButtonWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;
  + div {
    top: 54px;
    + div {
      top: 54px;
    }
  }
  [data-channel='Eyewearstore'] & {
    + div {
      top: 86px;
      + div {
        top: 86px;
      }
    }
  }
`;

const MobileButton = styled('button')`
  height: 40px;
  background: #ffffff;
  border: 1px solid #9a9a9a;
  width: auto;
  cursor: pointer;
  text-align: left;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 10px;
  font-size: 14px;
  text-transform: uppercase;
  width: 100%;
`;

const Filters = styled('div')`
  width: 100%;
  display: grid;
  grid-auto-columns: repeat(4, 1fr);
  grid-auto-flow: column;
  grid-gap: 8px;
  //margin-bottom: 0.5rem;
  > div {
    margin-bottom: 0;
  }
`;

const FilterIcon = styled(FontAwesomeIcon)`
  font-size: 1rem;
  color: #333333;
  margin-right: 10px;
`;

const ActiveFilters = styled('div')`
  aside {
    align-items: baseline;
    margin: 0;
    // ACTIVE FILTERS
    > div {
      button {
        margin: 10px 10px 10px 0;
        padding: 10px 5px;
        font-size: 12px;
        font-weight: normal;
        align-items: center;
        outline: none;
        background: #ebebeb;
        color: black;

        ${theme('below.lg')} {
          margin: 8px 2px;
          padding: 8px;
        }

        label {
          display: none;
        }
        span {
          padding-right: 5px;
          font-weight: normal;
        }
        svg {
          width: 10px;
          height: 10px;
          use {
            fill: black;
          }
        }
      }
    }
    // CLEAR
    > button {
      background: none;
      border: 0;
      text-decoration: none;
      font-weight: bold;
      font-size: 12px;
      background: #ebebeb;
      margin: 8px 2px;
      padding: 8px;
      text-transform: uppercase;
    }
  }
`;

const DrawerOuter = styled('div')`
  > .open {
    .filter-bottom, .close-modal {
      display: flex;
    }
  }
`;

class FilterRegular extends Component {
  render() {
    const { filters } = this.props;
    const sortOrders = get(this, 'props.sortOrders', []);

    return (
      <Fragment>
        <Below
          breakpoint="lg"
          render={() => {
            return (
              <Fragment>
                <ButtonWrapper>
                  {filters && filters.length > 0 ? (
                    <DrawerTrigger id="filterDrawer">
                      {({ showTarget }) => (
                        <MobileButton onClick={showTarget}>
                          <FilterIcon icon={['fa', 'sliders-h']} />
                          <p>{t('Filter')}</p>
                        </MobileButton>
                      )}
                    </DrawerTrigger>
                  ) : null}
                </ButtonWrapper>

                <DrawerOuter>
                  <DrawerTarget id="filterDrawer">
                    {({ hideTarget, isOpen }) => {
                      return (
                        <Drawer isOpen={isOpen} left>
                          <FilterDrawerRegular
                            close={hideTarget}
                            filters={filters}
                          />
                        </Drawer>
                      )
                    }}
                  </DrawerTarget>
                </DrawerOuter>

                <ActiveFilters>
                  <ActiveListFilters filters={filters} />
                </ActiveFilters>
              </Fragment>
            );
          }}
        />
      </Fragment>
    );
  }
}

export default FilterRegular;
